"use client";

import { useCallback, useMemo, useState } from "react";
import type { HubExchangeAccount } from "@cede/types";
import type { ExchangeSessionResult } from "../types";
import { useGrvtConnection } from "./useGrvtConnection";
import { useAuthenticatedWalletConnection } from "@/hooks/core/useAuthenticatedWalletConnection";
import { WALLET_ACTION_ROLE } from "@/hooks/core/useWalletActionGuard";

export function useGrvtSession(): ExchangeSessionResult {
  const grvtConnection = useGrvtConnection();
  const { authenticatedWalletAddress } = useAuthenticatedWalletConnection();

  const [selectedAccountId, setSelectedAccountId] = useState<number | null>(null);
  const selectedAccount = useMemo(() => {
    const accts = grvtConnection.grvtAccounts;
    if (selectedAccountId != null) return accts.find((a) => a.id === selectedAccountId) ?? null;
    return accts[0] ?? null;
  }, [grvtConnection.grvtAccounts, selectedAccountId]);

  const setSelectedAccount = useCallback(
    (account: HubExchangeAccount | null) => setSelectedAccountId(account?.id ?? null),
    [],
  );

  return {
    connection: grvtConnection,
    sessionStatus: grvtConnection.sessionStatus,
    accounts: grvtConnection.grvtAccounts,
    selectedAccount,
    setSelectedAccount,
    handleSetupAction: () => {},
    isSettingUp: false,
    requiredWalletRole: WALLET_ACTION_ROLE.MAIN_EVM,
    requiredWalletAddress: authenticatedWalletAddress ?? grvtConnection.connectedAddress,
    exchangeAccountAddress: grvtConnection.agentData.agentAddress,
    needsDeposit: false,
  };
}
